<template>
  <div>
    <div class="row">
      <div class="col-12 col-md-12 col-lg-9 mx-auto">
        <p>
          Impulsione ainda mais as suas vendas de seguros integrando o seu sistema de cotação às nossas APIs seguindo o
          procedimento descrito a seguir:
        </p>
      </div>
    </div>
    <!-- cards -->
    <div class="cards mt-5">
      <div class="row">
        <div class="col-12 col-md-12 col-lg-10 mx-auto">
          <div class="row">
            <div class="col-12 col-md-4 d-flex justify-content-center">
              <div class="card">
                <div class="icon"><img
                    src="/massificados/corporativo/gerenciador-parceiros-ui/fluxo/img/ic_corretor_com_relacionamento.svg">
                </div>
                <h1>CORRETORES COM RELACIONAMENTO</h1>
                <p>Para corretores e parceiros que já possuem relacionamento com a Tokio Marine, favor entrar em contato
                  com
                  seu gerente comercial responsável para iniciar o processo de integração.</p>
              </div>
            </div>
            <div class="col-12 col-md-4 d-flex justify-content-center">
              <div class="card">
                <div class="icon"><img
                    src="/massificados/corporativo/gerenciador-parceiros-ui/fluxo/img/ic_corretor_sem_relacionamento.svg">
                </div>
                <h1>CORRETORES SEM RELACIONAMENTO</h1>
                <p>Para os corretores que ainda não tem relacionamento com a Tokio, favor efetuar o cadastro da corretora no
                  Portal Institucional da Tokio Marine </p>
                <a href="https://portal.tokiomarine.com.br/parceiroNegocio/cadastro/corretor" target="_blank">www.tokiomarine.com.br</a>
              </div>
            </div>
            <div class="col-12 col-md-4 d-flex justify-content-center">
              <div class="card mb-0">
                <div class="icon"><img
                    src="/massificados/corporativo/gerenciador-parceiros-ui/fluxo/img/ic-integradoras.svg">
                </div>
                <h1>INTEGRADORAS /<br> INSURTECHS</h1>
                <p>Para outros tipos de parceiros, o processo de integração poderá prosseguir após análise inicial da
                  parceria. Para que essa análise seja feita, favor preencher o nosso</p>
                <a href="/massificados/corporativo/gerenciador-parceiros-ui/#/cadastro-portal-api" target="_blank">formulário de interesse</a>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <!-- Carousel wrapper -->
    <div id="carousel" class="carousel slide" data-mdb-ride="carousel">
      <!-- Indicators -->
      <ol class="carousel-indicators">
        <li data-mdb-target="#carousel" data-mdb-slide-to="0" class="active"></li>
        <li data-mdb-target="#carousel" data-mdb-slide-to="1"></li>
        <li data-mdb-target="#carousel" data-mdb-slide-to="2"></li>
        <li data-mdb-target="#carousel" data-mdb-slide-to="3"></li>
        <li data-mdb-target="#carousel" data-mdb-slide-to="4"></li>
      </ol>

      <!-- Inner -->
      <div class="carousel-inner">
        <!-- 1° passo -->
        <div class="carousel-item active">
          <div class="row passos mt-5">
            <div class="col-12 col-md-12 col-lg-10 mx-auto">
              <h1>1° PRIORIZAÇÃO DA INTEGRAÇÃO</h1>
              <hr class="divider">
              <p>
                Após a etapa de início da integração a solicitação será avaliada pelas áreas internas da Tokio Marine e
                priorizada em nossa fila de integração.
                Uma vez priorizada a atividade, o responsável técnico do parceiro receberá a documentação da API
                solicitada.
              </p>
              <img src="/massificados/corporativo/gerenciador-parceiros-ui/fluxo/img/fluxo-priorizacao.png" alt="">
            </div>
          </div>
        </div>

        <!-- 2° passo -->
        <div class="carousel-item">
          <div class="row passos mt-5">
            <div class="col-12 col-md-12 col-lg-10 mx-auto">
              <h1>2° PLANEJAMENTO DA INTEGRAÇÃO</h1>
              <hr class="divider">
              <p>Em seguida a Tokio Marine ficará no aguardo de um cronograma estimado pelo parceiro para construção da integração entre os sistemas, através das APIs.</p>
              <img src="/massificados/corporativo/gerenciador-parceiros-ui/fluxo/img/fluxo-planejamento.png" alt="">
            </div>
          </div>
        </div>

        <!-- 3° passo -->
        <div class="carousel-item">
          <div class="row passos mt-5">
            <div class="col-12 col-md-12 col-lg-10 mx-auto">
              <h1>3° CONSTRUÇÃO DA INTEGRAÇÃO</h1>
              <hr class="divider">
              <p>Durante o desenvolvimento do sistema do parceiro, o time de integração da Tokio Marine estará disponível para auxiliar caso necessário tirando dúvidas.</p>
              <img src="/massificados/corporativo/gerenciador-parceiros-ui/fluxo/img/fluxo-construcao.png" alt="">
            </div>
          </div>
        </div>

        <!-- 4° passo -->
        <div class="carousel-item">
          <div class="row passos mt-5">
            <div class="col-12 col-md-12 col-lg-10 mx-auto">
              <h1>4° VALIDAÇÃO TIME DE INTEGRAÇÃO TOKIO</h1>
              <hr class="divider">
              <p>Ao final do desenvolvimento, o parceiro deverá disponibilizar o acesso ao sistema recêm construído no ambiente de homologação para validação técnica e do produto.</p>
              <img src="/massificados/corporativo/gerenciador-parceiros-ui/fluxo/img/fluxo-validacao.png" alt="">
            </div>
          </div>
        </div>

        <!-- 4° passo -->
        <div class="carousel-item">
          <div class="row passos mt-5">
            <div class="col-12 col-md-12 col-lg-10 mx-auto">
              <h1>5° INÍCIO DA OPERAÇÃO</h1>
              <hr class="divider">
              <p>Finalizadas as etapas anteriores, o time da Tokio em contato com a equipe do parceiro combinará a melhor agenda para o início da operação em ambiente produtivo.</p>
              <img src="/massificados/corporativo/gerenciador-parceiros-ui/fluxo/img/fluxo-operacao.png" alt="">
            </div>
          </div>
        </div>

        <!-- 5° passo -->
        <!-- <div class="carousel-item">
          <div class="row passos mt-5 mb-5">
            <div class="col-12 col-md-12 col-lg-10 mx-auto">
              <h1>5° INÍCIO DA OPERAÇÃO</h1>
              <hr class="divider">
              <p>Finalizadas as etapas anteriores, o time da Tokio em contato com a equipe do parceiro combinará a melhor agenda para o início da operação em ambiente produtivo.</p>
              <img src="/massificados/corporativo/gerenciador-parceiros-ui/fluxo/img/fluxo-operacao.png" alt="">
            </div>
          </div>
        </div> -->

      </div>
      <!-- Inner -->

      <!-- Controls -->
      <a class="carousel-control-prev" href="#carousel" role="button" data-mdb-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Previous</span>
      </a>
      <a class="carousel-control-next" href="#carousel" role="button" data-mdb-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Next</span>
      </a>
    </div>
    <!-- Carousel wrapper -->

  </div>
</template>

<script>
import * as alertUtils from '@/utils/alert';

export default {
  data() {
    return {

    };
  },
  mounted() {

  },
  computed: {

  },
  methods: {
    openForm(event) {
      event.preventDefault();
      console.log('form');
      alertUtils.alertError("Em construção!");
    }
  }
};
</script>
